import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Table, Icon } from "semantic-ui-react";


import { format } from "date-fns";

const EmployeeRecordValue = ({ rows }) => {
  const navigate = useNavigate();

  return (
    <>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}>Id</Table.HeaderCell>
            <Table.HeaderCell width={2}>Status</Table.HeaderCell>
            <Table.HeaderCell width={2}>Organization</Table.HeaderCell>
            <Table.HeaderCell width={2}>Employee</Table.HeaderCell>
            <Table.HeaderCell width={2}>Updated At</Table.HeaderCell>

            <Table.HeaderCell width={1}>Edit/View</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rows &&
            rows.map((row, i) => {
              return (
                <Table.Row key={i}>
                  <Table.Cell>{row?.id}</Table.Cell>
                  <Table.Cell>{row?.status_text}</Table.Cell>
                  <Table.Cell>{row?.organization} # {row?.organization_name}</Table.Cell>
                  <Table.Cell>
                  {row?.employee} # {row?.employee_name} - {row?.employee_email}
                  </Table.Cell>
                  <Table.Cell>
                    {row?.created_at &&
                      format(new Date(row?.updated_at), "dd-MMM-yyyy hh:mm a")}
                  </Table.Cell>

                  <Table.Cell>
                    <Icon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/app/gpt-recommendation-log/edit/${row?.id}`)
                      }
                      name="edit"
                    />

                    <Icon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/app/gpt-recommendation-log/details/${row?.id}`)
                      }
                      name="eye"
                    />
                  </Table.Cell>
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
    </>
  );
};

EmployeeRecordValue.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default EmployeeRecordValue;
